module.exports = __webpack_public_path__ + "img/b_6.bae1915c.jpg";